module.exports = __webpack_public_path__ + "static/media/search-icons.2426b958.svg";